/**
 * Workbench → Fusion return path — the reverse of workbenchLink.ts.
 *
 * The Fusion box drills DOWN into the Crypto Workbench (buildWalletWorkbenchUrl);
 * this brings the officer back UP to the high-level case story, focusing the same
 * wallet they were looking at on-chain. The focus key is the BARE wallet address
 * (chain prefix stripped, EVM lowercased) so it matches the spine node's
 * canonical_id — CaseCanvasPage reads ?focus= and selects that node. Pure + no
 * backend: a client lookup against the already-fetched /api/v1/canvas envelope.
 */
import { bareWalletAddress } from '../../case-canvas/entityJoin';

type Navigate = (to: string) => void;

/** Build the Fusion-canvas URL for a case, optionally focusing one wallet node. */
export function buildFusionCanvasUrl(
  caseId: string | null | undefined,
  opts?: { address?: string | null },
): string | null {
  const id = (caseId || '').trim();
  if (!id) return null;
  let url = `/cases/${encodeURIComponent(id)}/canvas`;
  const addr = opts?.address ? bareWalletAddress(opts.address) : '';
  if (addr) url += `?focus=${encodeURIComponent(addr)}`;
  return url;
}

/** Navigate to the Fusion canvas (focusing the wallet when given). Returns false
 *  when there is no case to return to (the button should then stay hidden). */
export function openInFusion(
  navigate: Navigate,
  caseId: string | null | undefined,
  opts?: { address?: string | null },
): boolean {
  const url = buildFusionCanvasUrl(caseId, opts);
  if (!url) return false;
  navigate(url);
  return true;
}
